import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_EMAIL, NAV } from "../lib/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-teal-ink text-mist">
    <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 sm:px-8 lg:px-12">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo />
          <p className="mt-8 max-w-sm text-sm leading-relaxed text-mist/80">
            Agroecology, sustainable crop management and biological crop protection. Founded in New Zealand in 2019, working across Oceania.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="label-caps text-sage">Explore</p>
          <ul className="mt-6 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase()}`} className="link-underline text-sm text-mist/90">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="label-caps text-sage">Contact</p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="group mt-6 inline-flex items-center gap-2 font-display text-2xl font-light">
            <span className="link-underline">{CONTACT_EMAIL}</span>
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </div>
      <p aria-hidden="true" className="pointer-events-none mt-20 select-none whitespace-nowrap font-display text-[15.5vw] font-light leading-none tracking-[0.06em] text-mist/[0.07] lg:text-[13.2vw]">
        BIO SMART
      </p>
      <div className="mt-6 flex flex-col gap-3 border-t border-mist/15 pt-6 text-xs text-mist/70 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} Bio Smart Solutions Limited · Aotearoa New Zealand</p>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-mist">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
